module.exports = __webpack_public_path__ + "img/Y03L锂电池banner.bdaaad0b.jpg";